import React, { useEffect, useState } from "react";
import "../supplierAndManufacturers.scss";
import SlidingModal from "../../../CustomModal/SlidingModal";
import { Button } from "react-bootstrap";
import DeleteButton from "../Components/DeleteButton";
import EditModalBody, { getTodayFormatted } from "../Components/EditModalBody";
import ViewModalBody from "../Components/ViewModalBody";
import { CustomDeleteModal } from "../../../DeleteModal/DeleteModal";
import { useAuth } from "../../../context/Auth";
import { getAPIData, postRequest } from "../../../../Utils/commonApi";
import { CallToast } from "../../../PriceCalculator/modals/CustomToast";
import ContentLoader from "react-content-loader";
import { API_DOMENS } from "../../../../constants/apis.constants";


const AddEditSupplierAndManufacturers = ({
  show = false,
  itemId = 0,
  IsPsaSupplier = false,
  clientId = 0,
  isView = false,
  isFormPSA = false,
  isForClient = true,
  updateList = () => {},
  hideModal = () => { },
}) => {
  const { authTokens } = useAuth();
  const [isViewModal, setIsViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isInUse, setIsInUse] = useState(false);
  const [modalData, setModalData] = useState({});
  const [itemData, setItemData] = useState({});
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({})
  const [isStatusChanged, setIsStatusChanged] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (show) {
      setIsViewModal(isView);
      setModalData({ objId_SupplierManufacturer: itemId, AccessKey: JSON.parse(localStorage.getItem("user_MessageObj")), IsActive: true, ActivationDate: getTodayFormatted() });
      if (itemId !== 0) {
        getSupplierManufacturerById();
      }
    }
  }, [show])

  const createOrUpdateSupplierManufacturer = () => {
    console.log('modalData', modalData)
    console.log('modalData?.IsActive', modalData?.IsActive)
    setIsSaving(true);
    postRequest(authTokens, "CreateSupplierManufacturer", {
      ...modalData,
      Icon: modalData?.Icon ?? '',
      SubCategorySelected_List: JSON.stringify(modalData?.SubCategorySelected_List ?? []),
      CategorySelected_List: JSON.stringify(modalData?.CategorySelected_List ?? []),
      objId_Customer: clientId ?? 0,
      IsPsaSupplier: IsPsaSupplier,
      IsActive: modalData?.IsActive ?? false
    }, API_DOMENS.CC_API).then((response) => {
      if (response.Success) {
        CallToast("Created successfully", false, false, "v2style");
        hideModal(true);
        setModalData({ objId_SupplierManufacturer: 0, AccessKey: JSON.parse(localStorage.getItem("user_MessageObj")), IsActive: true });
      } else {
        CallToast("Something went wrong", false, false, "v2style");
      }
      setIsSaving(false);
    })
      .catch((err) => {
        CallToast("Something went wrong", false, false, "v2style");
        setIsSaving(false);
      });
  };

  async function changeSupplierManufacturerStatus(status) {
    return new Promise((resolve, reject) => {
      getAPIData(1087, authTokens, IsPsaSupplier ? {
        optionEnum1: itemId,
        optionEnum2: status ?? 0,
        optionEnum3: 1
      } : {
        optionEnum1: itemId,
        optionEnum2: status ?? 0,
      }, API_DOMENS.CC_API)
        .then((response) => {
          if (response.Success) {
            CallToast("Changed successfully", false, false, "v2style");
            setIsStatusChanged(true);
            updateList();
            getSupplierManufacturerById();
          } else {
            CallToast("Something went wrong", false, false, "v2style");
          }
        })
        .catch((error) => {
          reject(error);
          CallToast("Something went wrong", false, false, "v2style");
        });
    });
  }

  async function deleteSupplierManufacturer() {
    return new Promise((resolve, reject) => {
      getAPIData(1081, authTokens, {
        optionEnum1: itemId,
        optionEnum2: 0
      }, API_DOMENS.CC_API)
        .then((response) => {
          if (response.Success) {
            CallToast("Deleted successfully", false, false, "v2style");
            hideModal(true);
            setModalData({ objId_SupplierManufacturer: 0, AccessKey: JSON.parse(localStorage.getItem("user_MessageObj")), IsActive: true });
          } else {
            CallToast("Something went wrong", false, false, "v2style");
          }
        })
        .catch((error) => {
          reject(error);
          CallToast("Something went wrong", false, false, "v2style");
        });
    });
  }

  async function getSupplierManufacturerById() {
    setLoading(true);
    return new Promise((resolve, reject) => {
      getAPIData(1080, authTokens, isForClient ? (IsPsaSupplier ? {
        optionEnum1: itemId,
        optionEnum2: clientId,
        optionEnum3: 1
      } : {
        optionEnum1: itemId,
        optionEnum2: clientId,
      }) : (IsPsaSupplier ? {
        optionEnum1: itemId,
        optionEnum3: 1
      } : {
        optionEnum1: itemId,
      }), API_DOMENS.CC_API)
        .then((response) => {
          if (response/*?.mr?.Success*/) {
            setItemData(response);
            setModalData(prev => ({
              ...prev,
              ContactEmail: response.ContactEmail ?? '',
              Name: response?.Name ?? '',
              Website: response?.Website ?? '',
              IsSupplier: response?.IsSupplier ?? false,
              SubCategorySelected_List: response?.SubCategorySelected_List ?? [],
              IsManufacturer: response?.IsManufacturer ?? false,
              CategorySelected_List: response?.CategorySelected_List ?? [],
              ActivationDate: response?.ActivationDate ?? '',
              IsActive: response?.IsActive,
              Icon: response?.Logo
            }));
          } else {
            CallToast("Something went wrong", false, false, "v2style");
          }
          setLoading(false);
        })
        .catch((error) => {
          reject(error);
          setLoading(false);
          CallToast("Something went wrong", false, false, "v2style");
        });
    });
  }

  function isDefaultDate(dateStr) {
    return dateStr === "0001-01-01T00:00:00" || dateStr === "01/01/0001";
  }

  async function checkValidation() {
    let errors = 0;
    if (!modalData?.Name || modalData?.Name === "") {
      setErrors((prev) => ({ ...prev, Name: true }));
    }
    if ((!modalData?.IsSupplier && !modalData?.IsManufacturer)) {
      errors += 1;
      setErrors((prev) => ({ ...prev, Type: true }));
    }
    if (!modalData?.ContactEmail || modalData?.ContactEmail === "") {
      errors += 1;
      setErrors((prev) => ({ ...prev, ContactEmail: true }));
    }
    if (!modalData?.ActivationDate || modalData?.ActivationDate === "") {
      errors += 1;
      setErrors((prev) => ({ ...prev, ActivationDate: true }));
    }
    if (isDefaultDate(modalData?.ActivationDate)) {
      errors += 1;
      setErrors((prev) => ({ ...prev, ActivationDateType: true }));
    }
    if (!modalData?.Website || modalData?.Website === "") {
      errors += 1;
      setErrors((prev) => ({ ...prev, Website: true }));
    }
    if (!modalData?.CategorySelected_List || modalData?.CategorySelected_List?.length === 0) {
      errors += 1;
      setErrors((prev) => ({ ...prev, Category: true }));
    }
    // if (!modalData?.SubCategorySelected_List || modalData?.SubCategorySelected_List?.length === 0) {
    //   errors += 1;
    //   setErrors((prev) => ({ ...prev, Subcategory: true }));
    // }


    return errors;
  }

  console.log('clientId', clientId);

  return (
    <SlidingModal
      show={show}
      className="addEditSupplierAndManufacturersModal"
      parentID={"supplierAndManufacturers"}
      id="supplierAndManufacturersModal"
      onHide={() => {
        hideModal(isStatusChanged);
        setModalData({ objId_SupplierManufacturer: 0, AccessKey: JSON.parse(localStorage.getItem("user_MessageObj")), IsActive: true });
      }}
    >
      <SlidingModal.Header className="modalHeader">
        {loading ? <div className="d-flex align-items-center justify-content-center w-100">
          <div className="msp-service-update-loader ml-2 mr-1"></div>
          Loading..
        </div> :
          itemId == 0 ? <div className="w-100">Add</div> : <CompanyHeader name={isViewModal ? itemData?.Name : modalData?.Name} icon={isViewModal ? itemData?.Logo : modalData?.Icon} />}
        <span className="cursor-pointer" onClick={() => {
          hideModal(isStatusChanged);
          setModalData({ objId_SupplierManufacturer: 0, AccessKey: JSON.parse(localStorage.getItem("user_MessageObj")), IsActive: true });
        }}>
          <img src="/images/attack-surface/cross-icon.svg" alt="" />
        </span>
      </SlidingModal.Header>
      <SlidingModal.Body className="modalBody">
        {
          loading ? <SupplierAndManufacturerLoader /> : <>
            {isViewModal ? <ViewModalBody
              data={itemData}
              isForClient={isForClient}
              itemId={itemId}
              changeStatus={changeSupplierManufacturerStatus}
              clientId={clientId}
            /> : <EditModalBody
              isFormPSA={isFormPSA}
              modalData={modalData}
              setModalData={setModalData}
              errors={errors}
              setErrors={setErrors}
            />}
          </>
        }
      </SlidingModal.Body>
      {!isViewModal && (
        <SlidingModal.Footer className="modalFooter">
          {
            isViewModal ? <>
              <div></div>
              <Button className="hg-blue-btn" onClick={() => { setIsViewModal(false) }}>Edit</Button>
            </> : <>
              {isFormPSA ? <FromPSA name={'ConnectWise PSA'} icon={'/images/settings-v2/logo.svg'} /> : <DeleteButton onClick={() => { setShowDeleteModal(true) }} />}
              <div className="d-flex align-items-center">
                <Button className="hg-cancel-btn mr-2" onClick={() => {
                  if (isView) {
                    setIsViewModal(true);
                  } else {
                    hideModal(isStatusChanged);
                    setModalData({ objId_SupplierManufacturer: 0, AccessKey: JSON.parse(localStorage.getItem("user_MessageObj")), IsActive: true });
                  }
                }}
                >
                  Cancel
                </Button>
                <Button className="hg-blue-btn" disabled={isSaving}
                  onClick={async () => {
                    let errorCount = await checkValidation();
                    if (errorCount > 0) {
                      return
                    } else {
                      createOrUpdateSupplierManufacturer();
                    }
                  }}
                >
                  Save
                </Button>
              </div>
            </>
          }
        </SlidingModal.Footer>
      )}

      <CustomDeleteModal
        show={showDeleteModal}
        hideModal={() => { setShowDeleteModal(false) }}
        deleteButtonClass={isInUse ? "hg-blue-btn" : "hg-warning-btn"}
        deleteButtonText={isInUse ? "Ok" : "Delete"}
        deleteHeaderText={isInUse ? "Unable to delete" : "Delete"}
        deleteBodyText={isInUse ? "This item is associated with other records." : "Are you sure you want to delete?"}
        deleteFunction={() => { if (!isInUse) deleteSupplierManufacturer() }}
        deleteParams={{}}
        deleteType={"warningClose"}
      />
    </SlidingModal>
  );
};

export default AddEditSupplierAndManufacturers;

const CompanyHeader = ({
  name = '',
  icon
}) => (
  <div className="companyModalHeaderInfo">
    {icon && <img src={icon} width={14} height={14} alt="company logo" className="rounded-full mr-1" />}
    <div>{name}</div>
  </div>
)

const FromPSA = ({
  name = '',
  icon,
}) => (
  <div className="formPSAItem">
    {icon && <img src={icon} width={16} height={16} alt="company logo" className="rounded-full mr-1" />}
    <div>{name}</div>
  </div>
)



const SupplierAndManufacturerLoader = () => {
  return (
    <ContentLoader
      speed={2}
      width={"100%"}
      height={"100%"}
      viewBox="0 0 1500 900"
      backgroundColor="#F6F8FB"
      foregroundColor="#ecebeb"
    >
      <rect x="0" y="15" rx="3" ry="3" width="100%" height="250" />
      <rect x="0" y="290" rx="3" ry="3" width="100%" height="100" />
      <rect x="0" y="415" rx="3" ry="3" width="100%" height="100" />
      <rect x="0" y="540" rx="3" ry="3" width="100%" height="100" />
      <rect x="0" y="665" rx="3" ry="3" width="100%" height="100" />
      <rect x="0" y="780" rx="3" ry="3" width="100%" height="100" />
    </ContentLoader>
  );
};